import React, {useEffect, useState} from 'react';
import {Alert, Input} from 'antd';
import clientAPI from "../../service/ApiService";
import USPRow from "./USPRow";
import Pagination from "../Common/Pagination";
import {getUSPEndpoint} from "../../service/RoleService";

function USPTable(){

    const initialState = {
        page: 1,
        usps: [],
        sizePerPage: 20,
        totalSize: 0,
        error: null,
        loading: false
    };
    const [state, setState] = useState(initialState);

    useEffect(() => {
        getUsps()
    }, [state.page, state.sizePerPage]);// eslint-disable-line react-hooks/exhaustive-deps

    const getUsps = (search=null) => {
        setState({
            ...state,
            error: null,
            loading: true,
        });

        let requestUrl = getUSPEndpoint() + "/dashboard" +
            "?page=" + state.page +
            "&limit=" + state.sizePerPage +
            "&order=asc" +
            (search ? "&keyword=" + encodeURIComponent(search) : "");

        clientAPI.get(requestUrl)
            .then(response => {

                let usps = response.data?.data;
                if(!usps || usps.length <= 0 ){
                    setState({...state,
                        usps:[],
                        totalSize: 0,
                        page: state.page > 1 ? state.page-1 : state.page
                    });
                    return false
                }

                setState({
                    ...state,
                    error: null,
                    loading: false,
                    usps: usps,
                    totalSize: response.data.pagination.total
                })
            })
            .catch(error => {

                let msg = error?.response?.data?.statusCode?.msg
                setState({
                    ...state,
                    error: msg ?? null,
                    loading: false,
                    usps: [],
                    totalSize: null
                })
            })
    }

    const goToPage = ((page) => {
        setState({
            ...state,
            page: page
        })
    });

    const { Search } = Input;
    const [timer, setTimer] = useState(null);

    const setSearch = (event) => {
        var searchText = event.target.value;

        if (timer != null) {
            clearTimeout(timer);
        }

        setTimer(
            setTimeout(() => {
                getUsps(searchText)
            }, 300)
        )
    }

    return (
        <div>
            <p>Table with the latest usp's submitted by property users</p>
            {state.error && <Alert message={state.error} type="error" closable className="notification" />}
            <Search placeholder="Search submit request by id or name"
                    loading={state.loading}
                    onChange={(e) => setSearch(e)}
            />
            {state.usps &&
            <div className={"table-wrapper ant-table"}>
                <table className="table">
                    <thead className={"ant-table-thead"}>
                    <tr>
                        <th scope="col" style={{ color:"black" }}>Id</th>
                        {/*<th scope="col">Hotel</th>*/}
                        <th scope="col">URL</th>
                        <th scope="col">Created at</th>
                    </tr>
                    </thead>
                    <tbody className={"ant-table-tbody"}>
                    {state.usps.map((usp, index) =>
                        <USPRow key={index} usp={usp} />
                    )}
                    </tbody>
                </table>
                <Pagination
                    sizePerPage={state.sizePerPage}
                    totalSize={state.totalSize}
                    page={state.page}
                    goToPage={goToPage}
                />
            </div>
            }
        </div>
    );
};

export default USPTable;
